import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';

@inheritSerialization(Entity)
export class Adresse extends Entity {

  @deserialize
  numero = '';

  @deserializeAs('nom_voie')
  nomVoie = '';

  @deserializeAs('code_postal')
  codePostal = '';

  @deserializeAs('code_insee')
  codeInsee = '';

  @deserializeAs('nom_commune')
  nomCommune = '';

  @deserializeAs('nom_complementaire')
  nomComplementaire = '';

  @deserialize
  longitude = '';

  @deserialize
  latitude = '';

  @deserializeAs('api_adresse')
  apiAdresse = '';

  @deserializeAs('air_quality')
  airQuality = '';

  @deserializeAs('water_quality')
  waterQuality = '';

  @deserializeAs('connectivity_quality')
  connectivityQuality = '';

  public toString() {
    const adresses = [
      this.numero,
      this.nomVoie,
      this.nomComplementaire,
      this.codePostal,
      this.nomCommune
    ];

    const adressesFiltered = adresses.filter((adresse) => {
      return adresse != null;
    });

    return adressesFiltered.join(' ');
  }
}
